import { DVIRQuestion, DVIRQuestionType } from "../../../models";
import { DVIRQuestionForm } from "../TriplePInterface";

export interface DVIRQuestionPayload {
  data: {
    type: string;
    attributes: {
      question_text: string;
      question_type: DVIRQuestionType;
    };
  };
}

export const toDVIRQuestion = (form: DVIRQuestionForm): DVIRQuestionPayload => {
  return {
    data: {
      type: "dvir_questions",
      attributes: {
        question_text: form.questionText,
        question_type: form.questionType,
      },
    },
  };
};

export interface UpdateDVIRQuestionPayload {
  data: {
    id: string;
    type: string;
    attributes: {
      question_text: string;
      question_type: DVIRQuestionType;
    };
  };
}

export const toUpdateDVIRQuestion = (
  question: DVIRQuestion
): UpdateDVIRQuestionPayload => {
  return {
    data: {
      id: question.id,
      type: "dvir_questions",
      attributes: {
        question_text: question.questionText,
        question_type: question.questionType,
      },
    },
  };
};
